import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { ConnectedUsersBlock } from '../../_blocks/ConnectedUsers';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock, MaybeEmpty } from '../../types/api/Block';

export type ConnectedUsersWidget = WidgetShape<MaybeEmpty<ConnectedUsersBlock>, WidgetType.connectedUsers>;
export function ConnectedUsersWidget({
  blocks: [connectedUsersBlock],
  elementType,
  ...headerProps
}: ConnectedUsersWidget) {
  const { t } = useSonTranslation('ConnectedUsers');

  if (isEmptyBlock(connectedUsersBlock)) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.MEMBERS} title={t('widgetTitle')}>
      <ConnectedUsersBlock {...connectedUsersBlock} />
    </DefaultWidgetWithHeader>
  );
}
